class Progress {
  value = $state<number>
    (0);
}

export const progress = new Progress();